import type { IQuickBookStaffSelected } from './signal';

export type QuickBookingValidation =
  | { ok: true }
  | { ok: false; reason: 'NO_STAFF' }
  | { ok: false; reason: 'NO_SERVICE'; rowIndex: number };

/**
 * Booking chi hop le khi co it nhat mot staff va moi staff deu co it nhat mot dich vu.
 *
 * `Form.List` co the de lai o trong giua danh sach, nen dong `undefined` cung bi coi la thieu
 * dich vu — de lot se gui len server mot item khong co dich vu nao.
 */
export const validateQuickBookingRows = (rows?: IQuickBookStaffSelected[] | null): QuickBookingValidation => {
  if (!rows?.length) return { ok: false, reason: 'NO_STAFF' };

  const rowIndex = rows.findIndex(row => !row?.services?.length);
  if (rowIndex !== -1) return { ok: false, reason: 'NO_SERVICE', rowIndex };

  return { ok: true };
};
